<div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
  <div class="max-w-md w-full">
    <p-card styleClass="p-6 text-center">
      <!-- Header -->
      <div class="mb-6">
        <div class="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i class="pi pi-check-circle text-3xl text-green-600"></i>
        </div>
        <h1 class="text-2xl font-bold text-gray-800 mb-2" i18n>Payment Successful!</h1>
        <p class="text-gray-600" i18n>Your subscription has been activated successfully.</p>
      </div>

      <!-- Success Information -->
      <div class="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
        <div class="flex items-center gap-3">
          <i class="pi pi-check text-green-600"></i>
          <div class="text-left">
            <p class="font-medium text-green-800" i18n>What happens next?</p>
            <p class="text-sm text-green-700 mt-1">
              <span i18n>You can now access all features. Complete your company configuration to get started with your subscription.</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-3">
        <button 
          pButton 
          type="button" 
          label="Go to Company Configuration" 
          icon="pi pi-cog"
          class="w-full p-button-success"
          (click)="goToCompanyConfiguration()"
        ></button>
        
        <!-- <button 
          pButton 
          type="button" 
          label="Go to Dashboard" 
          icon="pi pi-home"
          class="w-full p-button-outlined"
          (click)="goToCompanyConfiguration()"
        ></button> -->
      </div>

      <!-- Additional Information -->
      <div class="mt-6 pt-6 border-t border-gray-200">
        <p class="text-sm text-gray-500 mb-2" i18n>Need help setting up your company?</p>
        <div class="text-sm text-gray-600">
          <p>📧 <a href="mailto:support@officeglobal.com" class="text-blue-600 hover:text-blue-800">support@officeglobal.com</a></p>
          <p>📞 <a href="tel:+442012345678" class="text-blue-600 hover:text-blue-800">+44 (0) 20 1234 5678</a></p>
        </div>
      </div>
    </p-card>
  </div>
</div>
